import { render, staticRenderFns } from "./saleAddonProfile.vue?vue&type=template&id=6f8e4114&scoped=true&"
import script from "./saleAddonProfile.vue?vue&type=script&lang=js&"
export * from "./saleAddonProfile.vue?vue&type=script&lang=js&"
import style0 from "./saleAddonProfile.vue?vue&type=style&index=0&id=6f8e4114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e4114",
  null
  
)

export default component.exports